'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { LinkStyle } from '@sola/ark-core/atoms/link-style/link-style.tsx';
import { ItemCardFooter } from '@sola/ark-core/molecules/item-card/item-card.tsx';
import { GraphQLCardExpiryStatus, GraphQLCommitment, GraphQLSupporterPaymentMethod } from '@sola/schema/dotcom/supporters/schema.generated.ts';
import { useSupporterQuery } from '@sola/supporter-sdk/hooks/base.ts';
import { commitmentsQuery, paymentMethodsQuery } from '@sola/supporter-sdk/queries.ts';
import { PaymentMethodRemoveDialog } from '../../organisms/payment-method-remove-dialog/payment-method-remove-dialog.tsx';
import { PaymentMethodUpdateSheet } from '../../organisms/payment-method-update-sheet/payment-method-update-sheet.tsx';
export const useComponentData = currentPaymentMethod => {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [paymentMethodsQuery, commitmentsQuery];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: paymentMethodData
  } = useSupporterQuery(t0);
  const [paymentMethods] = paymentMethodData;
  let t1;
  if ($[1] !== currentPaymentMethod || $[2] !== paymentMethods) {
    t1 = paymentMethods ? paymentMethods.filter(pm => pm.id !== currentPaymentMethod.id && pm.status !== "Expired" && pm.creditCard?.expiryStatus !== GraphQLCardExpiryStatus.Expired) : [];
    $[1] = currentPaymentMethod;
    $[2] = paymentMethods;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = {
      alternatePaymentMethods: t1
    };
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export type PaymentMethodCardFooterProps = {
  paymentMethod: GraphQLSupporterPaymentMethod;
  recurringCommitments?: GraphQLCommitment[];
  allCommitments?: GraphQLCommitment[];
  onRemoveSuccess?: () => void;
  onRemoveError?: () => void;
};
export const PaymentMethodCardFooter: React.FC<PaymentMethodCardFooterProps> = t0 => {
  const $ = _c(21);
  const {
    paymentMethod,
    recurringCommitments: t1,
    allCommitments: t2
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const recurringCommitments = t3;
  let t4;
  if ($[2] !== t2) {
    t4 = t2 === undefined ? [] : t2;
    $[2] = t2;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const allCommitments = t4;
  const {
    t
  } = useTranslation("my");
  const {
    alternatePaymentMethods
  } = useComponentData(paymentMethod);
  const isShowingRemoveBtn = !recurringCommitments.length || !!alternatePaymentMethods?.length;
  let t5;
  if ($[4] !== alternatePaymentMethods || $[5] !== isShowingRemoveBtn || $[6] !== paymentMethod || $[7] !== recurringCommitments || $[8] !== t) {
    t5 = isShowingRemoveBtn && <PaymentMethodRemoveDialog openTrigger={<LinkStyle noUnderline={true} noPadding={true} size="lg" purpose="negative"><button type="button">{t("payments.removeMethod")}</button></LinkStyle>} selectedPaymentMethod={paymentMethod} recurringCommitments={recurringCommitments} alternatePaymentMethods={alternatePaymentMethods} />;
    $[4] = alternatePaymentMethods;
    $[5] = isShowingRemoveBtn;
    $[6] = paymentMethod;
    $[7] = recurringCommitments;
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t("payments.editMethod");
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <LinkStyle noUnderline={true} noPadding={true} size="lg"><button type="button">{t6}</button></LinkStyle>;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== allCommitments || $[15] !== paymentMethod || $[16] !== t7) {
    t8 = <PaymentMethodUpdateSheet openTrigger={t7} paymentMethod={paymentMethod} commitments={allCommitments} />;
    $[14] = allCommitments;
    $[15] = paymentMethod;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t5 || $[19] !== t8) {
    t9 = <ItemCardFooter justify="end"><div className="flex justify-end items-center gap-comfy-sm md:gap-comfy-md"><div className="flex gap-comfy-md ml-auto">{t5}{t8}</div></div></ItemCardFooter>;
    $[18] = t5;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
};